import Store from "App/Store.js";

export default checkoutBasketDiscounts => Store.dispatch({type: "checkoutBasketDiscounts", checkoutBasketDiscounts});
